module.exports = __webpack_public_path__ + "static/media/travel-3@2x.049bee28.png";